import { api, apiV2 } from '@/plugins/axios'
import Service from '../service'

/**
 * @type {Rest}
 */
export default class Rest extends Service {

    /**
     * @param {String} resource 
     */
    constructor (resource = '', options = {}) {
        super(options)
        this.http = api
        this.http2 = apiV2
        this.resource = resource
    }

    store () {
        return this.http.get(this.resource)
    }

    storeV2 () {
        return this.http2.get(this.resource)
    }

    /**
     * Função básica REST que busca todas as instâncias
     * 
     * @param {String} url 
     * @param {Object} params 
     */
    getAll(url, params, config = {}) {
        return this.http.get(
            this.constructor.normalize(this.resource, url),
            {
                params,
                ...config
            }
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    getAllV2(url, params, config = {}) {
        return this.http2.get(
            this.constructor.normalize(this.resource, url),
            {
                params,
                ...config
            }
        ).then(response => {
            if (response && response?.data && response.data?.status === 'error') return Promise.reject(response)

            return response
        })
    }

    /**
     * Função básica REST que busca uma instância
     * apenas
     * 
     * @param {String} url 
     * @param {Integer|String} id 
     * @param {Object} params 
     */
    get(url, id, params, config = {}) {
        return this.http.get(
            this.constructor.normalize(this.constructor.normalize(this.resource, url), id),
            {
                params,
                ...config
            }
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    getV2(url, id, params, config = {}) {
        return this.http2.get(
            this.constructor.normalize(this.constructor.normalize(this.resource, url), id),
            {
                params,
                ...config
            }
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    /**
     * Função básica REST que cria uma instância
     * 
     * @param {String} url 
     * @param {Object} data 
     */
    create(url, data) {
        return this.http.post(
            this.constructor.normalize(this.resource, url),
            data
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    createV2(url, data) {
        return this.http2.post(
            this.constructor.normalize(this.resource, url),
            data
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    /**
     * Função básica REST que atualiza uma instância
     * 
     * @param {String} url 
     * @param {Integer|String} id 
     * @param {Object} data 
     */
    update(url, id, data) {
        //config = {} removed in parameter
        return this.http.put(
            this.constructor.normalize(this.constructor.normalize(this.resource, url), id),
            {
                ...data
            },
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    updateV2(url, id, data) {
        //config = {} removed in parameter
        return this.http2.put(
            this.constructor.normalize(this.constructor.normalize(this.resource, url), id),
            {
                ...data
            },
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }
    // para dinamico salvar como formData
    updateDataFieldDynamic(url, id, data) {
        return this.http.put(
            this.constructor.normalize(this.constructor.normalize(this.resource, url), id), data,
            {headers: {'content-type': 'application/x-www-form-urlencoded'}}
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)
            return response
        })
    }

    /**
     * Função básica REST que remove uma instância
     * por ID
     * 
     * @param {String} url 
     * @param {Integer|String} id 
     */
    delete(url, id, config = {}) {
        return this.http.delete(
            this.constructor.normalize(this.constructor.normalize(this.resource, url), id),
            {
                ...config
            }
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    deleteV2(url, id, config = {}) {
        return this.http2.delete(
            this.constructor.normalize(this.constructor.normalize(this.resource, url), id),
            {
                ...config
            }
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    destroy(url, id, data) {
        return this.http.delete(
            this.constructor.normalize(this.constructor.normalize(this.resource, url), id),
            {
                data: data
            }
        )
    }

    destroyV2(url, id, data) {
        return this.http2.delete(
            this.constructor.normalize(this.constructor.normalize(this.resource, url), id),
            {
                data: data
            }
        )
    }

    /**
     * @param {String} start
     * @param {String} end
     * @returns {String}
     */
    static normalize (start, end) {
        return `${start}/${end}`.replace(/([^:]\/)\/+/g, '$1')
    }


}